import { useState } from 'react';
import { Stepper, Step, StepLabel, StepConnector } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import NotStartedIcon from '@mui/icons-material/NotStarted';
import { styled } from '@mui/material/styles';
import EditForm from './editForm';
import axiosInstance from '../../helpers/axios';

// Custom StepIcon component
const StepIconRoot = styled('div')(({ theme, ownerState }) => ({
    display: 'flex',
    alignItems: 'center',
    ...(ownerState.completed && {
        color: "#12B76A",
    }),
    ...(ownerState.error && {
        color: theme.palette.error.main,
    }),
    ...(ownerState.pending && {
        color: "orange",
    }),
    ...(ownerState.notInitiated && {
        color: "orange",
    }),
}));

function CustomStepIcon(props) {
    
    const { active, completed, error, icon } = props;
    let iconComponent;

    if (completed) {
        iconComponent = <CheckCircleIcon />;
    } else if (error) {
        iconComponent = <WarningIcon />;
    } else if (!active) {
        iconComponent = <NotStartedIcon />;
    } else {
        iconComponent = <HourglassEmptyIcon />;
    }

    return (
        <StepIconRoot
            ownerState={{
                completed,
                error,
                pending: !completed && !error && active,
                notInitiated: !completed && !error && !active,
            }}
        >
            {iconComponent}
        </StepIconRoot>
    );
}
function CustomStepper({eligibility,user,steps,activeStep,prodArray,applicationId,apptrackeR}) {
const [editFormModal,setEditFormModal]=useState(false)
const [userData, setUserData] = useState({});
const handleAction=(indexes,activeStep)=>{
  // const urlProfile = `/products/instituteId?instituteId=B2C`;
  // axiosInstance.get(urlProfile)
  //     .then((res) => {
  //       })
  //     .catch((err) => err)
    if(indexes === 0)
        {
          const urlProfile = `/summary/user?id=${user?.userId}&applicationId=${user?.applicationId}`;
          axiosInstance.get(urlProfile).then((res) => {
        const data = res?.data?.data;
        setUserData({
          applicationId:data?.applicationId,
          userId:data?.userId,
          instituteName: data.instituteName,
          courseName: data.courseName,
          courseFees: data.courseFees,
          email: data.email,
          dob: data.dateOfBirth,
          gender: data.gender,
          tenure: data.loanTenure,
          firstName: data.firstName,
          lastName: data.lastName,
          mobile: data.mobile,
          currentAddress: data.currentAddress,
          officeAddress: data.officeAddress,
          maritalStatus: data.maritalStatus,
          studentName: data.studentName,
          salary: data.salary,
          panId: data.panId,
          aadhaarId: data.aadhaarId,
          currentPincode: data.currentPincode,
          currentCity: data.currentCity,
          currentState: data.currentState,
          officePincode: data.officePincode,
          officeCity: data.officeCity,
          officeState: data.officeState,
        });
        setEditFormModal(true)
      }).catch(error => {
        console.error("Error fetching user data:", error);
      });
        }
}





    return (
<>
      <EditForm curruser={user} formOpen={editFormModal} prodArray={prodArray} setFormOpen={setEditFormModal} userData={userData}/>
      <Stepper alternativeLabel activeStep={activeStep} connector={
    <StepConnector
      sx={{
        '& .MuiStepConnector-line': {
          borderColor: 'gray',
        },
      }}
    />
  } >
        {steps?.map((step, index) => {  
          let status;
          const indexes = step.index; 
          if (eligibility !== null) {
            if (step.label === "Consent") {
              if (eligibility !== 1) {
                status = "completed";
              
              } else {
                status = "pending";
              }
            } else if (step.index === 5) {
              if (eligibility !== 2) {
                status = "completed";
                
              } else {
                status = "alert";
              }
            } 
            else if (step.index === 5) {
              if (eligibility !== 2) {
                status = "completed";
                
              } else {
                status = "pending";
              }
            } 

            else if (step.index ===0  ){

              if((activeStep=== 0 || activeStep === 1) && eligibility!==2){
           
           
                status = "pending"
             }else if(eligibility===2){
                 status = "pending"
             }
            else  { 
              status = "completed" 
              
            }  
              
            }
          else if (step.index ===2    ){

              if(apptrackeR.cibil=== true ){
                
                status = "completed"
              }

            else if (apptrackeR.cibil=== "To Do"){ 
              
              status = "pending"}  
              else if (apptrackeR.cibil=== false){ 
              
                status = "alert"}  

            }
            else if (step.index ===3  ){

              if(apptrackeR.bsaLinkStatus=== true){
                
                status = "completed"
              }
            else if (apptrackeR.postSanctionStatus=== true){ 
              
              status = "completed"}  
              else { 
              
                status = "pending"}  

            }
            else if (step.index ===4  ){

              if(apptrackeR.digilocker=== true ){
                
                status = "completed"
              }
            else if (apptrackeR.digilocker=== "To Do"){ 
              
              status = "pending"}  
              else if (apptrackeR.digilocker=== false){ 
              
                status = "alert"}  

            }
            else if (step.index ===9  ){
              if(apptrackeR.selfie=== true ){
           
                status = "completed"
              }

            else if (apptrackeR.selfie=== "To Do"){ 

              status = "pending"} 

              else if (apptrackeR.selfie=== false){ 
              
                status = "alert"}  

            }
            else if (step.index ===6  ){

              if(apptrackeR.agreementStatus=== true ){
                
                status = "completed"
              }

            else if (apptrackeR.agreementStatus=== "To Do"){ 
              
              status = "pending"}  
              else if (apptrackeR.agreementStatus=== false){ 
              
                status = "alert"}  

             }
               else if (step.index ===7  ){

        if(apptrackeR.upiMandateStatus=== true ){
           
           status = "completed"
         }

       else if (apptrackeR.upiMandateStatus=== "To Do"){ 
        
        status = "pending"}  
        else if (apptrackeR.upiMandateStatus=== false){ 
        
          status = "alert"}  

             }
            else if (step.index === 8) {
              if ( apptrackeR.status==="Application Disbursed") {
                status = "completed";
                
              } else {
                status = "pending";
              }
            } 

          }
          
          return (
            <Step
              onClick={() => handleAction(indexes, activeStep)}
              key={index}
              active={status === "pending"}
            >
              <StepLabel
                StepIconComponent={(props) => {
                  let error = status === "alert";
                  let completed = status === "completed";
                  let active = status === "pending";
                  return (
                    <CustomStepIcon
                      {...props}
                      error={error}
                      completed={completed}
                      active={active}
                    />
                  );
                }}
              >
                {step.label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
</>
    );
}

export default CustomStepper;
